import React, { useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import { toast } from "react-toastify";
import { formatNumberWithCommas2 } from "../../utils/commonUtils";
import { useDispatch, useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import { addInvestmentFee } from "../../redux/slices/feeSettingSlice";

const InvestmentProjectSetting = () => {
  const [formData, setFormData] = useState({
    amount: "",
    min_fee: "",
    max_fee: "",
  });

  const dispatch = useDispatch()

  const investment_fee = useSelector(
    (state) => state.feeSetting?.feeSettings?.investment_fee
  );

  useEffect(() => {
    if (investment_fee) {
      setFormData({
        amount: investment_fee.amount || "",
        min_fee: investment_fee.min_fee || "",
        max_fee: investment_fee.max_fee || "",
      });
    }
  }, [investment_fee]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let adjustedValue = value.replace(/,/g, "");

    if (name === "amount") {
      const floatValue = parseFloat(value);
      adjustedValue = Math.min(Math.max(floatValue, 1), 100).toString();
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: adjustedValue,
    }));
  };

  const status = useSelector((state) => state.feeSetting?.investmentFeeStatus);

  const handleSubmit = async () => {
    if (!formData.amount || !formData.min_fee || !formData.max_fee) {
      toast.error("Please fill in all the required fields.");
      return;
    }
    try {
      await dispatch(addInvestmentFee(formData));
      toast.success("Investment fee successfully set");
    } catch (error) {}
  };


  return (
    <>
      <div className="flex flex-row justify-between items-center gap-4">
        <label
          htmlFor="amount"
          className="text-[14px] text-[#4D5464]  font-bold tracking-[0.07px] pl-28"
        >
          Amount (%)
        </label>
        <div className="flex justify-end pr-28">
          <input
            name="amount"
            id="name"
            type="number"
            value={formData.amount}
            onChange={handleInputChange}
            placeholder="Type here..."
            className="pl-[12px] text-[#333843] text-right p-2 rounded-lg text-[14px] bg-[#F9F9FC] w-full border-2 border-[#E0E2E7]"
          />
        </div>
      </div>
      <div className="flex flex-row mt-4 justify-between items-center">
        <label
          htmlFor="minimum_fee"
          className="text-[14px] text-[#4D5464] font-bold tracking-[0.07px] pl-28"
        >
          Minimun Fee
        </label>
        <div className="flex justify-end pr-28">
          <input
            name="min_fee"
            id="name"
            type="text"
            value={formatNumberWithCommas2(formData.min_fee)}
            onChange={handleInputChange}
            placeholder="Type here..."
            className="pl-[12px] text-[#333843] text-right p-2 rounded-lg text-[14px] bg-[#F9F9FC] w-full border-2 border-[#E0E2E7]"
          />
        </div>
      </div>
      <div className="flex flex-row mt-4 justify-between items-center">
        <label
          htmlFor="state"
          className="text-[14px] text-[#4D5464] font-bold tracking-[0.07px] pl-28"
        >
          Maximun Fee
        </label>
        <div className="flex justify-end pr-28">
          <input
            name="max_fee"
            id="name"
            type="text"
            value={formatNumberWithCommas2(formData.max_fee)}
            onChange={handleInputChange}
            placeholder="Type here..."
            className="pl-[12px] text-[#333843] text-right p-2 rounded-lg text-[14px] bg-[#F9F9FC] w-full border-2 border-[#E0E2E7]"
          />
        </div>
      </div>
      <div className="flex justify-center">
        <button
          className="flex gap-1 mt-4  rounded-lg items-center justify-center bg-blue-600 text-white py-2 px-4"
          disabled={status === "loading"}
          onClick={handleSubmit}
        >
          {status === "loading" ? (
            <>
              <FaSpinner className="animate-spin" />
              <p className="text-sm font-semibold whitespace-nowrap">
                Submitting ...
              </p>
            </>
          ) : (
            <>
              <FiPlus className=" font-bold text-base" />
              <p className="text-sm font-semibold whitespace-nowrap">Submit</p>
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default InvestmentProjectSetting;
